import { render, staticRenderFns } from "./ProfileMirHasCard.vue?vue&type=template&id=62e24492&scoped=true&"
import script from "./ProfileMirHasCard.vue?vue&type=script&lang=js&"
export * from "./ProfileMirHasCard.vue?vue&type=script&lang=js&"
import style0 from "./ProfileMirHasCard.vue?vue&type=style&index=0&id=62e24492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e24492",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/home/bitrix/frontend/components/other/Button.vue').default,Hint: require('/home/bitrix/frontend/components/other/Hint.vue').default,MirMasterpiece: require('/home/bitrix/frontend/components/forms/MirMasterpiece.vue').default,MtModalFull: require('/home/bitrix/frontend/components/Modal/MtModalFull.vue').default,PriceList: require('/home/bitrix/frontend/components/terms/PriceList.vue').default,MtModal: require('/home/bitrix/frontend/components/Modal/MtModal.vue').default})
